export const plansHelper = {
  types: {
    fam: ['familiar', ' fam', 'fam ', '_fam', 'fam_'],
    ind: ['individual', ' ind', 'ind ', '_ind', 'ind_', 'único']
  },
  compile(plans, plan) {
    if (plans) {
      if (plan) {
        return this.getBasePlan(JSON.parse(JSON.stringify(plans)), plan)
      }
      return this.getBasePlan(JSON.parse(JSON.stringify(plans)))
    }
    return {}
  },
  getBasePlan (plansList, plan) {
    const plans = this.getPlansSorted(plansList)
    const method = plan?.method || plans[0]?.method
    const value = plan?.value || plans[0]?.planValue
    const splittedName = plan?.name.split(' - ') || plans[0]?.name.split(' - ')

    return {
      name: splittedName.length < 3 ? splittedName[0] : splittedName[1],
      method,
      value,
      packs: this.getPlansGrouped(plans)
    }
  },
  getPlansSorted (plans) {
    const newPlans = plans.map((plan) => {
      const splittedName = plan.name.split(plan.name.indexOf(' - ') >= 0 ? ' - ' : ' ')
      const isFamType = this.types.fam.filter((type) => plan.name.toLowerCase().includes(type))
      const isIndType = this.types.ind.filter((type) => plan.name.toLowerCase().includes(type))

      const resumeName = splittedName.filter((name) => isIndType.length
        ? !this.types.ind.includes(name.toLowerCase())
        : !this.types.fam.includes(name.toLowerCase())
      )

      return {
        ...plan,
        isFreemium: plan.isFreemium || !plan.planValue,
        type: isFamType.length ? 'familiar' : 'individual',
        resumeName: resumeName.join(' ')
      }
    })

    newPlans.sort((a, b) => {
      if (a.planValue === b.planValue) {
        return this.types.ind.includes(a.type) ? -1 : 1
      } else {
        return a.planValue < b.planValue ? -1 : 1
      }
    })

    return newPlans
  },
  getPlansGrouped (plans) {
    return {
      freemium: plans.filter((plan) => plan.isFreemium),
      single: plans.filter((plan) => !plan.isFreemium && this.types.ind.includes(plan.type)),
      family: plans.filter((plan) => !plan.isFreemium && this.types.fam.includes(plan.type))
    }
  }
}